import {Component, OnInit} from '@angular/core';
import {Bundle} from "../services/bundle";
import {Router} from "@angular/router";
import {ShipmentRoutesService} from "../services/shipment-routes.service";
import {ShipmentDriversService} from "../services/shipment-drivers.service";
import {ShipmentDriver} from "../services/shipment-driver";

declare let NProgress: any;

@Component({
    selector: 'app-shipment-drivers',
    templateUrl: './shipment-drivers.component.html',
    styleUrls: ['./shipment-drivers.component.scss'],
    providers: [ShipmentDriversService]
})

export class ShipmentDriversComponent implements OnInit {

    shipmentDrivers: ShipmentDriver[];

    constructor(
                public shipmentDriversService: ShipmentDriversService,
                private router: Router) {
    }

    ngOnInit() {
        this.shipmentDriversService.getShipmentDrivers().then(shipmentDrivers => {
            this.shipmentDrivers = shipmentDrivers;
        });
    }

    add() {
        let driover = ShipmentDriver.fromJSON({});
        driover.branch = 'rin';
        driover.name = 'New Driver';

        this.shipmentDriversService.addShipmentDriver(driover).then(bundle => {
            this.router.navigateByUrl('/shipment-drivers/' + bundle.id);
        });
    }

    delete(bundle: ShipmentDriver) {
        if (confirm('Er du sikker på at du vil slette ' + bundle.name + ' ?')) {
            this.shipmentDriversService.deleteShipmentDriver(bundle).then(result => {
                this.shipmentDriversService.getShipmentDrivers().then(bundles => {
                    this.shipmentDrivers = bundles;
                });
            });
        }
    }
}
